import * as React from 'react';

import {Illustration} from 'shells/illustrations/illustration';

import {SwoopArrow} from './swoop-arrow';

import styles from './graphic-team.module.css';

export class GraphicTeam extends React.PureComponent<Record<any, any>> {
    render() {
        return (
            <div id='cx-team-image' className={styles['graphic-container']}>
                <Illustration src='marketing-plan-stars' width={200} />
                {/* @ts-expect-error */}
                <SwoopArrow startSelector='cx-team-image' destinationSelector='help-menu-button' />
            </div>
        );
    }
}
